import type { CheckboxProps } from "@hightouch/formkit";
import { Controller } from "react-hook-form";
import type { SharedProps } from ".";
import { Checkbox } from "@hightouch/htui";

export const FKCheckbox = ({
  name,
  label,
  isDisabled,
}: CheckboxProps & SharedProps) => (
  <Controller
    name={name}
    render={({ field }) => (
      <Checkbox
        isChecked={Boolean(field.value)}
        isDisabled={isDisabled}
        label={label}
        onChange={field.onChange}
      />
    )}
  />
);
